import angular from 'angular';
import portaro from '../portaro';
import TabSystem from './tab-system';
import {DatasourceGroup, Kind, SearchType} from '../commons/constants/portaro.constants';
import KpCover from './kp-cover/KpCover.svelte';
import KpRecordHierarchyTrees from './kp-record-hierarchy-trees/KpRecordHierarchyTrees.svelte';
import KpRecordDetailTable from '../commons/components/kp-record-detail-table/KpRecordDetailTable.svelte';

portaro.controller('AuthorityCtrl', ['$scope', 'searchManagerFactory', 'CONTEXT_PATH', 'directoryDataService', '$window', 'searchService', 'modalConversationService', 'recordService', 'recordDataService', 'currentDepartment',
    function($scope, searchManagerFactory, CONTEXT_PATH, directoryDataService, $window, searchService, modalConversationService, recordService, recordDataService, currentDepartment) {

        $scope.$window = $window;
        $scope.CONTEXT_PATH = CONTEXT_PATH;
        $scope.kpCoverComponent = KpCover;
        $scope.kpRecordHierarchyTreesComponent = KpRecordHierarchyTrees;
        $scope.kpRecordDetailTable = KpRecordDetailTable;

        $scope.init = async function() {
            angular.extend($scope, window.model);

            $scope.record = $scope.view.record;

            recordService.getRecordHierarchyTrees($scope.record).then((hierarchyTrees => {
                $scope.hierarchyTrees = hierarchyTrees;
            }));

            if ($scope.record.directoryId) {
                directoryDataService.getInsight($scope.record.directoryId, $scope.record.cover ? $scope.record.cover.id : null)
                    .then(function(insight) {
                        $scope.directoryInsight = insight;
                        $scope.images = insight.sampleFiles.filter(item => item.image);
                    });
            }

            $scope.copyRecord = async function() {
                await recordService.copyRecordToSpecifiedFondAndAddRecordHoldingThrowingToModal($scope.record);
            };

            $scope.loadOperations = function () {
                if (!$scope.operationListSearchManager) {
                    const staticParams = {
                        type: SearchType.TYPE_RECORD_OPERATION_SEARCH,
                        kind: Kind.KIND_RECORD_OPERATION,
                        record: [$scope.record.id],
                        pageSize: 10
                    };
                    $scope.operationListSearchManager = searchManagerFactory.createLocalSearch(searchService.search.bind(searchService), staticParams);
                    $scope.operationListSearchManager.newSearch();
                }
            };

            recordService.getAllRecordHoldings($scope.record, currentDepartment)
                .then((recordHoldings) => {
                    $scope.recordHoldings = recordHoldings;
                    return recordHoldings;
                });
        };

        $scope.deleteRecordHolding = async function (recordHolding) {
            await recordService.deleteRecordHolding(recordHolding);
        };


        const DEFAULT_TAB_PRIORITIES = {
            NONE: 300,
            DETAIL: 200,
            MARC: 100,
            ATTACHMENTS: 400,
            OPERATIONS: 60
        };
        $scope.detailTabs = new TabSystem(Object.assign({}, DEFAULT_TAB_PRIORITIES, window.authorityTabPriorities));

        $scope.updateWithExternalRecord = async function () {

            let initialFrontendParams = {};

            initialFrontendParams.q = $scope.record.name;

            const modalModel = {
                staticSearchParams: {
                    kind: Kind.KIND_AUTHORITY,
                    type: SearchType.TYPE_SEARCH_SELECTION,
                    datasourceGroup: DatasourceGroup.EXTERNAL
                },
                initialFrontendParams
            };

            await recordService.updateWithExternalRecordAndReloadThrowingToToast($scope.record, modalModel);
        }

    }]);
